import {queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import type {GetClientsRequest} from '../types';

import {getClients} from './getClients';

export const clientsQueryOptions = (req: GetClientsRequest = {}) =>
  queryOptions({
    queryKey: keys.clients.list(req),
    queryFn: () => getClients(req),
    staleTime: 30_000,
  });
